<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 unnumbered" id="section" style="width:550px;"><div class="section level3" id="about-the-author">
<div class="section level5" id="to-kusha-and-to-the-earth-we-walked.">
<p style="text-align: right; padding-top:300px; font-size:12pt; font-family:calibri;width:550px;"><em>To Kusha, and to the Earth we walked.</em></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?289de644